(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.BaseStep = (function(superClass) {
    extend(BaseStep, superClass);

    function BaseStep(parent) {
      this.validate = bind(this.validate, this);
      this.getPrev = bind(this.getPrev, this);
      BaseStep.__super__.constructor.call(this);
      this.__destroyed = false;
      this.parent = parent;
      this.ignore('prev');
      this.__name = ko.observable();
    }

    BaseStep.prototype.beforePrev = function() {
      return this.destroy();
    };

    BaseStep.prototype.afterPrev = function() {
      return void 0;
    };

    BaseStep.prototype.beforeSet = function() {
      return void 0;
    };

    BaseStep.prototype.afterSet = function() {
      return void 0;
    };

    BaseStep.prototype.beforeNext = function() {
      return this.destroy();
    };

    BaseStep.prototype.afterNext = function() {
      return void 0;
    };

    BaseStep.prototype.getPrev = function() {
      return this.parent.clearHistoryPrev();
    };

    BaseStep.prototype.destroy = function() {
      if (this.__destroyed) {
        return;
      }
      return this.__destroyed = true;
    };

    BaseStep.prototype.validate = function() {
      return true;
    };

    return BaseStep;

  })(KoModel);

}).call(this);
